module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"wh100 gl-presence-confirm-form\" name=\"container\">\n	<style>\n		.gl-presence-confirm-form {\n			padding: 10px;\n		}\n\n		.gl-presence-confirm-form.blink {\n			background-color: #ccbb66 !important;\n			color: #333333 !important;\n		}\n	</style>\n\n	<p><b>Необходимо подтвердить ваше присутствие на рабочем месте.</b></p>\n	<button on-click=\"onConfirmClick\">Подтвердить</button>\n</div>\n")
  }
  return __output.join("");

}